import React from "react";
import { useLocation } from "react-router-dom";
import { Languages } from "lucide-react";

import { useI18n } from "../i18n";

const INTERNAL_PREFIXES = [
  "/admin",
  "/sales",
  "/owner",
  "/me",
  "/venue-report",
  "/partner",
];

function isInternalPath(pathname) {
  return INTERNAL_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));
}

export default function LanguageSelector({ compact = false }) {
  const { locale, locales, setLocale, t } = useI18n();
  const location = useLocation();

  if (isInternalPath(location.pathname)) return null;

  return (
    <label className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-black/30 px-2.5 py-1.5 text-white/75">
      <Languages size={compact ? 14 : 16} className="text-cyan-300" aria-hidden="true" />
      <span className="sr-only">{t("language.label")}</span>
      <select
        value={locale}
        onChange={(event) => setLocale(event.target.value)}
        aria-label={t("language.label")}
        className="max-w-[8.5rem] bg-transparent text-xs font-bold text-white outline-none md:max-w-none"
      >
        {locales.map((item) => (
          <option key={item.code} value={item.code} className="bg-black text-white">
            {item.label}
          </option>
        ))}
      </select>
    </label>
  );
}
